module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-00.9df1062e.png";